/**
* @ngdoc directive
* @name Ordered Header
*
* @description
  Header with top / down arrows that sets order property and reverse type on click
  Used on tables
*
* @attributes
* @param {String} orderproperty - property to set as ordered on click
* @param {String} headername - header name
* @param {Boolean} left - show arrows on left / right
*
* @example
  <ordered-header orderproperty="caption" headername="Name"></ordered-header>
*/

(function() {

  orderedHeader.$inject = ["PATH"];
  app.directive('orderedHeader', orderedHeader);

  function orderedHeader(PATH) {
    var directive = {
      restrict: 'E',
      templateUrl: PATH.components + 'orderedHeaderDirective/orderedheader.tpl.html',
      replace: true,
      scope: true,
      link: link
    };

    return directive;

    function link($scope, $element, $attrs) {
      $scope.orderproperty = $attrs.orderproperty;
      $scope.headername = $attrs.headername;
      $scope.left = $attrs.left;

      var setOrder = function(orderProp) {
        $scope.$parent.reverse = orderProp === $scope.$parent.orderProperty ? !$scope.reverse : false;
        $scope.$parent.orderProperty = orderProp;
      };

      $scope.setOrder = $scope.setOrder || setOrder;

      $scope.showArrowUp = function(orderProp) {
        return $scope.orderProperty === orderProp && !$scope.reverse;
      };

      $scope.showArrowDown = function(orderProp) {
        return $scope.orderProperty === orderProp && $scope.reverse;
      };
    }
  }

})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/orderedHeaderDirective/orderedHeaderDirective.js